module.exports = __webpack_public_path__ + "static/media/submit.95d8f7b6.svg";